import { render, staticRenderFns } from "./force-pull-from-odoo-modal.vue?vue&type=template&id=63bfaf4f&scoped=true"
import script from "./force-pull-from-odoo-modal.vue?vue&type=script&lang=js"
export * from "./force-pull-from-odoo-modal.vue?vue&type=script&lang=js"
import style0 from "./force-pull-from-odoo-modal.vue?vue&type=style&index=0&id=63bfaf4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfaf4f",
  null
  
)

export default component.exports